// extracted by mini-css-extract-plugin
export default {"mealTable":"c2MLMTwu5D1Or5cxtjEg"};